import React, { useEffect } from "react";
import { BASE_URL } from "../../global";
import moment from "moment";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Checkbox, Grid, TextField, useMediaQuery } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from "@mui/icons-material/Help";
import Box from "@mui/material/Box";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import { Autocomplete, Typography, Modal } from "@mui/material";
import { showComponent } from "../helper/helpers";
import TextEditor from "./textEditor";
import VerifiedIcon from "@mui/icons-material/Verified";
import DangerousIcon from "@mui/icons-material/Dangerous";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { updateSRFAnalytics } from "../../utils/analytics/srfAnalytics";
import { green, orange } from "@material-ui/core/colors";
import { checkDSStatusByCount } from "./countTester";
import { srfListGuide } from "./guide";
import { useSettings, useSrfDetails } from "./editSrf/fetchHandlers";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ErrorModal from "../../utils/components/errorModal";
import ListWrap from "../commonComponent/listWrap";
import SrfActionButtons from "./srfActionbutton";
import ExcelDownload from "../../utils/components/excelDownload";
import { getFormattedDates } from "../../utils/utils";
import RenderEmailModal from "../../utils/components/renderEmailModal";
import { AccreditationTypeOptions } from "../../constants/srfConstants";
import SrfAudit from "./editSrf/srfAudit";
import { handleSrfCopy } from "./copySrf";
import { paginationrowsPerPageOptions } from "../../constants/commonConst";

import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UndoIcon from "@mui/icons-material/Undo";
import MailOffIcon from "@mui/icons-material/MarkEmailUnread"; // or any "off" icon
import MailIcon from "@mui/icons-material/Mail";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import {
  Select,
  MenuItem,
  FormControl,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const getStatusColor = (status) =>
  status === "yes" ? green[500] : orange[500];

// datatablse packages
var $ = require("jquery");
$.DataTable = require("datatables.net");

const columns = [
  { id: "id", label: "Sr.No.", minWidth: 40 },
  { id: "customerName", label: "Client", minWidth: 40 },
  // { id: "address", label: "Address", minWidth: 40 },
  {
    id: "Division",
    label: "Division",
    align: "left",
    minWidth: 40,
  },
  {
    id: "Department",
    label: "Department",
    align: "left",
    minWidth: 40,
  },
  {
    id: "calType",
    label: "Calibration Type",
    minWidth: 40,
    align: "left",
  },
  {
    id: "serviceReqNumber",
    label: "Service Req Number",
    minWidth: 40,
    align: "left",
    back: "#37AFE1",
  },
  {
    id: "poNumber",
    label: "PO Number",
    minWidth: 40,
    align: "left",
    back: "#37AFE1",
  },

  {
    id: "commitedDate",
    label: "Commited delivery Date",
    minWidth: 110,
    align: "left",
  },
  {
    id: "entryDate",
    label: "Issue Date",
    minWidth: 110,
    align: "left",
  },
  {
    id: "userName",
    label: "Created by",
    minWidth: 40,
    align: "left",
  },
];

function createData(
  id,
  customerName,
  // address,
  companyHierarchy,
  calType,
  serviceReqNumber,
  poNumber,
  commitedDate,
  receiptDate,
  clientId,
  userName,
  dcNumber,
  dcDate,
  entryDate,
  approvedby,
) {
  return {
    id,
    customerName,
    // address,
    companyHierarchy,
    calType,
    serviceReqNumber,
    poNumber,
    commitedDate,
    receiptDate,
    clientId,
    userName,
    dcNumber,
    dcDate,
    entryDate,
    approvedby,
  };
}
const notNeededColumn = ["id", "status", "approvedby", "calType", "clientId"];

const actionOptions = [
  {
    value: "delete",
    label: "Multiple delete",
    icon: <DeleteIcon fontSize="small" color="error" />,
  },
  {
    value: "approve",
    label: "Approve",
    icon: <CheckCircleIcon fontSize="small" color="success" />,
  },
  { value: "withdraw", label: "Withdraw", icon: <UndoIcon fontSize="small" /> },
  {
    value: "stop-mail",
    label: "Stop due mail",
    icon: <MailOffIcon fontSize="small" />,
  },
  {
    value: "active-mail",
    label: "Active due mail",
    icon: <MailIcon fontSize="small" />,
  },
];

export default function SrfsList(props) {
  const srfListGuides = srfListGuide();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const urlPath = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = React.useState(() =>
    Number(sessionStorage.getItem("ListPageCount") || 0),
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(() =>
    Number(sessionStorage.getItem("ListRowsPerPage") || 30),
  );
  const [finalData, setFinalData] = React.useState([]);
  const [srfList, setSrfList] = React.useState([]);
  const [dBStatus, setDBStatus] = React.useState("");
  const [Type, setType] = React.useState(null);
  const [AccreditationTypeArray, setAccreditationTypeArray] = React.useState(
    [],
  );
  const [loading, setLoading] = React.useState(false);
  const [selectSRF, setSelectSRF] = React.useState("");
  const [searchBy, setSearchBy] = React.useState(
    sessionStorage.getItem("searchBy") || "service Request Number",
  );
  const [searchKey, setSearchKey] = React.useState(
    sessionStorage.getItem("searchKey") || "",
  );
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [totalRows, setTotalRows] = React.useState(0);
  const [userType, setUserType] = React.useState(localStorage.getItem("type"));
  const [userId, setUserId] = React.useState(localStorage.getItem("id"));
  const [branch, setBranch] = React.useState(localStorage.getItem("branch"));
  const validCompanies = localStorage.getItem("validClients");
  const userName = localStorage.getItem("userName");
  const [openProgressModal, setOpenProgressModal] = React.useState(false);
  const [srfRowId, setsrfRowId] = React.useState(null);
  const [instrumentArray, setInstrumentArray] = React.useState([]);
  const [companyName, setCompanyName] = React.useState("");
  const [srfNumber, setSrfNumber] = React.useState("");
  const [invoiceStatus, setInvoiceStatus] = React.useState("");
  const [srfAnalyticsData, setsrfAnalyticsData] = React.useState([]);
  const [pushIArray, setPushIArray] = React.useState([]);
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [rowDaata, setRowDaata] = React.useState([]);
  const [actionValue, setActionValue] = React.useState("");

  const [isCSRF, setIsCSRF] = React.useState(false);
  const [selectedRowId, setSelectedRowId] = React.useState(null);
  const [printmodalopen, setPrintModalOpen] = React.useState(false);
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [searched, setSearched] = React.useState(false);
  const [editAccess, setEditAccess] = React.useState(
    localStorage.getItem("editAccess")?.split(",").map(Number),
  );
  const [settings, fetchSettings] = useSettings({});
  const [open, setOpen] = React.useState(false);
  const [selectedColumn, SetSelectedColumn] = React.useState([]);
  const [progressSearchBy, setProgressSearchBy] = React.useState("DUCID");
  const [progressSearchKey, setProgressSearchKey] = React.useState("");
  const [progressSearched, setProgressSearched] = React.useState(false);
  const [progressStatusFinalData, setProgressStatusFinalData] = React.useState(
    [],
  );
  const [hideSrfData, setHideSrfData] = React.useState({
    hideRow: false,
    calType: null,
    srfNumberData: [],
    usersData: [],
    selectedSRFIds: "",
    hideSrfUserIds: "",
  });
  const historyData =
    JSON.parse(sessionStorage.getItem("historicalTable")) || false;

  const [selected, setSelected] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [auditModalOpen, setAuditModalOpen] = React.useState(false);
  // data hooks
  const [srfDetails, updateSrfDetails, fetchSrfDetails] = useSrfDetails({
    customerAnnextureFilePaths: [],
    calType: 2,
  });
  const handleOpenAuditModal = (row) => {
    setSelectedRow(row);
    setAuditModalOpen(true);
  };
  const handleCloseAuditModal = () => {
    setAuditModalOpen(false);
    setSelectedRow(null);
  };
  const handleSelectRow = (id) => {
    setSelected((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };
  const isSelected = (id) => selected.includes(id);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const openErrorModal = (errorMessage, stackTrace, fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const handleOpenTimeline = (id, customerName, serviceReqNumber) => {
    //row.id,row.customerName,row.serviceReqNumber
    updateSRFAnalytics(id);
    setCompanyName(customerName);
    setSrfNumber(serviceReqNumber);
    setOpenProgressModal(true);
    setsrfRowId(id);
  };

  const handleCloseimeline = () => {
    setOpenProgressModal(false);
  };
  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);
  const handlePrintModalOpen = (id) => {
    setSelectedRowId(id);
    setPrintModalOpen(true);
  };
  const handlePrintModalClose = () => {
    setPrintModalOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  var refresh = () => {
    window.location.reload(false);
  };

  const getQuery = (count = false, removePagination = false) => {
    let whereConditions = "WHERE pl.status = 1 ";
    let pagination_settings = "";
    let extraJoin = ""; //  for additional joins datasheets assigned user
    if (searchBy !== "" && searchKey != "") {
      let colName = {
        Client: "pr.companyName",
        "service Request Number": "pl.serviceReqNumber",
        "PO Number": "pl.poNumber",
        "Division,Department": "pl.companyHierarchy",
      }[searchBy];
      whereConditions += `and LOWER(${colName}) like LOWER('%${searchKey}%') `;
    }

    if (to != null && from != null) {
      const { fromDate, toDate } = getFormattedDates(from, to);
      if (whereConditions === "") {
        whereConditions = " and ";
      } else {
        whereConditions += " and ";
      }

      whereConditions += ` pl.entryDate between '${fromDate}' and '${toDate}' `;
    }

    whereConditions +=
      (userType == 4 || userType == 5) && branch && branch.length
        ? (whereConditions ? "  " : "") + `and pr.branch in (${branch})`
        : "";

    // whereConditions += (whereConditions ? " and " : "") + " pl.status = 1 ";

    if (Type) {
      whereConditions +=
        whereConditions.length > 0
          ? ` and (pl.calType=${Type})`
          : ` and (pl.calType=${Type})`;
    }
    if (selectSRF) {
      whereConditions +=
        whereConditions.length > 0
          ? ` and (pl.serviceReqNumber='${selectSRF}')`
          : ` and (pl.serviceReqNumber='${selectSRF}')`;
    }

    if (userType == "2" && props.rolesInfo?.currentRole?.id != 2) {
      extraJoin = ` LEFT JOIN datasheets ds ON ds.serviceReqNumber = pl.serviceReqNumber AND ds.assignedUser = ${userId} AND ds.status = 1 `;

      whereConditions +=
        whereConditions.length > 0
          ? ` AND (pl.createdby = ${userId} OR ds.id IS NOT NULL)`
          : ` AND (pl.createdby = ${userId} OR ds.id IS NOT NULL)`;
    }

    if (settings["hideSRF"]?.value === "true") {
      whereConditions +=
        whereConditions.length > 0
          ? ` AND (pl.hideSrfUserIds IS NULL OR FIND_IN_SET(${userId}, pl.hideSrfUserIds) = 0)`
          : ` AND (pl.hideSrfUserIds IS NULL OR FIND_IN_SET(${userId}, pl.hideSrfUserIds) = 0)`;
    }

    if (userType == "8") {
      whereConditions +=
        validCompanies?.length > 0
          ? whereConditions.length > 0
            ? ` and pl.clientId in (${validCompanies})`
            : ``
          : "";
    }
    if (props.isCount) {
      const today = new Date().toISOString().slice(0, 10);
      whereConditions +=
        (whereConditions ? " and " : " and ") +
        `DATE(pl.lastmodified) = '${today}'`;
    }

    if (!removePagination && rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

    let data = {
      query: `SELECT pl.poNumber, pl.approvedby, pl.companyHierarchy, pl.clientId, pr.uniCode, pr.companyName, pl.serviceReqNumber, pl.calType, pl.committedDeliveryDate, pl.receiptDate, pl.id, pl.entryDate, u.userName FROM srfs AS pl LEFT JOIN clients AS pr ON pl.clientId = pr.id LEFT JOIN users AS u ON u.id = pl.createdby ${extraJoin} ${whereConditions} GROUP BY pl.id order by pl.id DESC ${pagination_settings}`,
    };
    if (count)
      data.query = `SELECT COUNT(DISTINCT pl.id) AS no_of_rows FROM srfs AS pl LEFT JOIN clients AS pr ON pl.clientId = pr.id LEFT JOIN users AS u ON u.id = pl.createdby ${extraJoin} ${whereConditions}`;

    return data;
  };

  // api calls
  function getTotalRows() {
    // var data = {
    //   query:
    //     userType == "2"
    //       ? `select count(*) as no_of_rows from srfs where createdby=${userId}`
    //       : `select count(*) as no_of_rows from srfs`,
    // };
    let data = getQuery(true);
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0].no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getTotalRows", "Srf List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  }

  function getSrfsList() {
    setLoading(true);
    let data = getQuery();
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setSrfList([...res.data]);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("srfs data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getSrfsList", "Srf List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  }

  function fetchAllDataForExcel() {
    const data = getQuery(false, true);
    axiosWithToken
      .post(BASE_URL + "dynamic", data)
      .then((res) => {
        const processed = res.data.map((item) => {
          const obj = {
            companyName: item.companyName,
            // addresses: item.addresses,
            serviceReqNumber: item.serviceReqNumber,
          };
          if (settings?.companyHierarchy?.value) {
            const [division, department] =
              item.companyHierarchy.split(",") || "";
            obj.division = division;
            obj.department = department;
          }
          obj.poNumber = item.poNumber;
          obj.calType = AccreditationTypeOptions[item.calType] || item.calType;
          obj.committedDeliveryDate = item.committedDeliveryDate
            ? moment(item.committedDeliveryDate).format("DD-MM-YYYY")
            : "";
          obj.receiptDate = item.receiptDate
            ? moment(item.receiptDate).format("DD-MM-YYYY")
            : "";
          obj.entryDate = item.entryDate
            ? moment(item.entryDate).format("DD-MM-YYYY")
            : "";
          obj.createdby = item.userName;
          return obj;
        });
        setFinalData(processed);
      })
      .catch((err) =>
        console.log("Failed to fetch data for Excel export", err),
      );
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if (storedSearchBy) {
      setSearched(true);
    }
  }, [storedSearchBy]);
  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setPage(0);
    setSearched(true);
    getSrfsList();
    getTotalRows();
    fetchAllDataForExcel();
  };
  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    setPage(0);
    setSearchBy("service Request Number");
    setSearchKey("");
    setFrom(null);
    setTo(null);
    setSearched(false);
    setType("");
    setAccreditationTypeArray([]);
    setSelectSRF("");
    navigate("/inward");
  };

  function getAccreditationType() {
    const url = `${BASE_URL}dynamic`;
    const Payload = {
      query: `select id,serviceReqNumber,calType from srfs where calType = ${Type} and status = 1 order by id DESC`,
    };
    axiosWithToken
      .post(url, Payload)
      .then((res) => {
        setAccreditationTypeArray(res.data);
      })
      .catch((err) => console.log(err));
  }
  function getSrfAnalytics() {
    const url = `${BASE_URL}dynamic`;

    const Payload = {
      query: `SELECT srfAnalytics.*, srfInstruments.instrumentId,srfInstruments.requestedDucName, srfInstruments.DUCID , srfInstruments.serialNumber  FROM srfAnalytics LEFT JOIN srfInstruments ON srfAnalytics.srfInstrumentId = srfInstruments.id WHERE srfAnalytics.srfId =${srfRowId} and srfAnalytics.status = 1 and srfInstruments.status = 1`,
    };
    axiosWithToken
      .post(url, Payload)
      .then((res) => {
        setsrfAnalyticsData(res.data);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getSrfAnalytics", "Srf List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  }
  const getInstrumentsList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "instruments")
      .then((res) => {
        setInstrumentArray(res.data);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getInstrumentsList", "Srf List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  };
  const generatePushIArray = (instrumentArray) => {
    const newPushIArray = [];

    for (let i = 0; i < instrumentArray.length; i++) {
      if (instrumentArray[i].instrumentName) {
        newPushIArray.push({
          label:
            instrumentArray[i].id + ", " + instrumentArray[i].instrumentName,
        });
      }
    }

    return newPushIArray;
  };

  useEffect(() => {
    setPushIArray(generatePushIArray(instrumentArray));
  }, [instrumentArray]);

  useEffect(() => {
    getSrfAnalytics();
  }, [srfRowId]);

  useEffect(() => {
    checkDSStatusByCount(setDBStatus);
    getInstrumentsList();
    fetchSettings([
      "CSRFS",
      "companyHierarchy",
      "hideSRF",
      "AuditSRF",
      "Certificate Number",
      "Certificate Number NABL",
      "Certificate Number IAS",
      "Certificate Number NONNABL",
      "serviceReqNumber",
      "serviceReqNumberNABL",
      "serviceReqNumberIAS",
      "serviceReqNumberNONNABL",
      "ULR number",
      "ULR ID",
    ]);
  }, []);

  useEffect(() => {
    if (settings["CSRFS"]?.value === "true") {
      setIsCSRF(true);
    }
  }, [settings]);

  useEffect(() => {
    getAccreditationType();
  }, [Type]);

  useEffect(() => {
    getSrfsList();
    getTotalRows();
  }, [rowsPerPage, page, Type, settings["hideSRF"]]);

  useEffect(() => {
    if (searched == false) {
      getSrfsList();
      getTotalRows();
      fetchAllDataForExcel();
    }
    if (searched) {
      setPage(sessionStorage.getItem("ListPageCount") || 0);
    }
  }, [searched]);

  const submitSiteDelete = async (id) => {
    let url = BASE_URL;
    const idString = (Array.isArray(id) ? id : [id]).join(",");
    try {
      const response = await axiosWithToken.post(url + "dynamic", {
        query: `SELECT id FROM srfInstruments WHERE srfsId IN (${idString});`,
      });

      const idsToDelete = response.data.map((d) => d.id);

      // Delete the SRFs
      await axiosWithToken.post(url + "dynamic", {
        query: `UPDATE srfs SET status = -1 WHERE id IN (${idString});`,
      });

      if (idsToDelete.length > 0) {
        const idsToDeleteString = idsToDelete?.join(",");
        await Promise.all([
          axiosWithToken.post(url + "dynamic", {
            query: `UPDATE datasheets SET status = -1 WHERE id IN (${idsToDeleteString});`,
          }),
          axiosWithToken.post(url + "dynamic", {
            query: `UPDATE certificates SET status = -1 WHERE id IN (${idsToDeleteString});`,
          }),
          axiosWithToken.post(url + "dynamic", {
            query: `UPDATE srfInstruments SET status = -1 WHERE id IN (${idsToDeleteString});`,
          }),
        ]);
      }
      toast("Srf deleted successfully!");
      setTimeout(refresh, 1000);
    } catch (err) {
      console.log("error : ", err);
    }
  };

  const generateRowDaata = (srfList) => {
    const newRowDaata = [];

    for (let i = 0; i < srfList.length; i++) {
      newRowDaata.push(
        createData(
          srfList[i].id,
          srfList[i].companyName +
            (srfList[i].uniCode ? " (" + srfList[i].uniCode + ")" : ""),
          // srfList[i].addresses,
          srfList[i].companyHierarchy,
          srfList[i].calType == 1
            ? "NABL"
            : srfList[i].calType == 2
              ? "IAS"
              : "NON NABL",
          srfList[i].serviceReqNumber,
          srfList[i].poNumber,
          moment(srfList[i].committedDeliveryDate).format("DD-MM-YYYY"),
          moment(srfList[i].receiptDate).format("DD-MM-YYYY"),
          srfList[i].clientId,
          srfList[i].userName,
          srfList[i].dcNumber,
          moment(srfList[i].dcDate).format("DD-MM-YYYY"),
          moment(srfList[i].entryDate).format("DD-MM-YYYY"),
          srfList[i].approvedby,
        ),
      );
    }

    return newRowDaata;
  };

  const renderPrintModal = () => {
    return (
      <Modal
        open={printmodalopen}
        onClose={handlePrintModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        size="md"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            height: 250,
            bgcolor: "background.paper",
            border: "2px solid cadetblue",
            padding: "30px",
            textAlign: "center",
            borderRadius: "25px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                flexDirection: "column",
              }}
            >
              <div style={{ flex: 1, width: "100%" }}>
                <span>Download SRF AND CSRF</span>
              </div>
              <div style={{ flexBasis: "50px" }}></div>
              <div style={{ flex: 1, width: "100%", display: "flex" }}>
                <div style={{ flex: 1, width: "100%" }}>
                  <Tooltip
                    title="Ignore Warning and adds Reading"
                    placement="top-start"
                  >
                    <Button
                      component={Link}
                      to={`/srf/printSrf/${selectedRowId}`}
                      variant="contained"
                      size="small"
                      sx={{ m: 0, ml: 2 }}
                    >
                      SRF Print
                    </Button>
                  </Tooltip>
                </div>
                <div style={{ flex: 1, width: "100%" }}>
                  <Tooltip
                    title="Clear readings but keeps instrument"
                    placement="top-start"
                  >
                    <Button
                      component={Link}
                      to={`/srf/printCsrf/${selectedRowId}`}
                      variant="contained"
                      size="small"
                      sx={{ m: 0, ml: 2 }}
                    >
                      CSRF Print
                    </Button>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    );
  };

  const progressModalRender = () => {
    //srfAnalyticsData
    function getStatusObject(progressPercent) {
      if (progressPercent === null) {
        return {
          inwordStatus: "no",
          dataSheetStatus: "no",
          approveStatus: "no",
          dispatchedStatus: "no",
        };
      }

      const inwordStatus = progressPercent >= 25 ? "yes" : "no";
      const dataSheetStatus = progressPercent >= 50 ? "yes" : "no";
      const approveStatus = progressPercent >= 75 ? "yes" : "no";
      const dispatchedStatus = progressPercent >= 90 ? "yes" : "no";

      return {
        inwordStatus,
        dataSheetStatus,
        approveStatus,
        dispatchedStatus,
      };
    }

    const statusObjects = srfAnalyticsData?.map((item) => ({
      id: item.id,
      srfId: item.srfId,
      srfInstrumentId: item.srfInstrumentId,
      status: getStatusObject(item.progressPercent),
      instrumentId: item.instrumentId,
      DUCID: item.DUCID,
      serialNumber: item.serialNumber,
      requestedDucName: item.requestedDucName,
    }));

    let data = {
      query: `SELECT CASE WHEN EXISTS (SELECT 1 FROM customInvoice WHERE serviceReqNumber LIKE '%${srfNumber}%') THEN 'yes' ELSE 'no' END AS Response`,
    };
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setInvoiceStatus(res.data[0].Response);
      })
      .catch((err) => {
        console.log("InvoiceStatus data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "renderTimeline", "Srf List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });

    const search1 = () => {
      const filteredData =
        statusObjects.filter((obj) => {
          const searchKey = [
            { key: "DUCID", label: "DUCID" },
            { key: "serialNumber", label: "Serial Number" },
          ]?.find((ele) => ele.label == progressSearchBy)?.key; // Get the key to search by
          return obj[searchKey]
            ?.toLowerCase()
            .includes(progressSearchKey.toLowerCase()); // Case-insensitive search
        }) || [];

      setProgressStatusFinalData(filteredData);
      setProgressSearched(true);
    };

    const clearSearch1 = () => {
      setProgressStatusFinalData(statusObjects);
      // Logic to clear the search and reset
      setProgressSearched(false);
      setProgressSearchKey("");
    };

    let mainData =
      progressStatusFinalData?.length > 0
        ? progressStatusFinalData
        : statusObjects;

    return (
      <Modal open={openProgressModal} onClose={handleCloseimeline}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 1100,
            height: 550,
            overflowY: "scroll",
          }}
        >
          <Button
            variant="contained"
            size="small"
            style={{ float: "right" }}
            onClick={() => setOpenProgressModal(false)}
          >
            X
          </Button>
          <TableContainer component={Paper}>
            <Box>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell
                      style={{
                        border: "none",
                        fontWeight: "bold",
                        fontSize: "20px",
                        padding: 0,
                        width: "200px",
                      }}
                    >
                      Client:
                    </TableCell>
                    <TableCell
                      style={{ border: "none", fontSize: "18px", padding: 0 }}
                    >
                      {companyName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      style={{
                        border: "none",
                        fontWeight: "bold",
                        fontSize: "20px",
                        padding: 0,
                      }}
                    >
                      SRF Number:
                    </TableCell>
                    <TableCell
                      style={{ border: "none", fontSize: "18px", padding: 0 }}
                    >
                      {srfNumber}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      style={{
                        border: "none",
                        fontWeight: "bold",
                        fontSize: "20px",
                        padding: 0,
                      }}
                    >
                      Total Instruments:
                    </TableCell>
                    <TableCell
                      style={{ border: "none", fontSize: "18px", padding: 0 }}
                    >
                      {statusObjects?.length}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      style={{
                        border: "none",
                        fontWeight: "bold",
                        fontSize: "20px",
                        padding: 0,
                      }}
                    >
                      Invoice Status:
                    </TableCell>
                    <TableCell
                      style={{
                        border: "none",
                        fontSize: "18px",
                        padding: 0,
                        color: getStatusColor(invoiceStatus),
                      }}
                    >
                      {invoiceStatus === "yes" ? (
                        <VerifiedIcon />
                      ) : (
                        <DangerousIcon />
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>

              <Grid
                container
                spacing={2}
                alignItems="center"
                style={{ padding: "5px 0px" }}
              >
                <Grid item xs={12} sm={6} md={2} lg={2.5}></Grid>
                <Grid item xs={12} sm={6} md={2} lg={2.5}></Grid>
                <Grid item xs={12} sm={5} md={2} lg={2.5}>
                  <Autocomplete
                    className="Listinputcss"
                    sx={{
                      m: 0,
                      width: "100%",
                    }}
                    size="small"
                    value={progressSearchBy}
                    id="srflist-searchby"
                    options={[
                      { key: "DUCID", label: "DUCID" },
                      { key: "serialNumber", label: "Serial Number" },
                    ]}
                    isOptionEqualToValue={(option, value) =>
                      option.label === value
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Search By" />
                    )}
                    onInputChange={(event, newInputValue) => {
                      setProgressSearchBy(newInputValue);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={2.5}>
                  <TextField
                    className="Listinputcss"
                    style={{ width: "100%" }}
                    id="srflist-searchbytext"
                    label={"enter " + progressSearchBy}
                    size="small"
                    inputProps={{
                      autoComplete: "off",
                    }}
                    variant="outlined"
                    value={progressSearchKey}
                    onChange={(e) => {
                      setProgressSearchKey(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2} lg={2}>
                  <Button
                    id="srflist-searchbtn"
                    variant="contained"
                    size="small"
                    color={progressSearched ? "error" : "primary"}
                    onClick={() => {
                      progressSearched ? clearSearch1() : search1();
                      // handleFilterClose();
                    }}
                  >
                    {progressSearched ? <RestartAltIcon /> : <SearchIcon />}
                  </Button>
                </Grid>
              </Grid>
            </Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ fontWeight: "bold", backgroundColor: "#1976d2" }}
                  >
                    Sr. No
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: "bold", backgroundColor: "#1976d2" }}
                  >
                    Instrument Name
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: "bold", backgroundColor: "#1976d2" }}
                  >
                    DUCID
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: "bold", backgroundColor: "#1976d2" }}
                  >
                    Serial Number
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", backgroundColor: "#1976d2" }}
                  >
                    Inward Status
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", backgroundColor: "#1976d2" }}
                  >
                    DataSheet Status
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", backgroundColor: "#1976d2" }}
                  >
                    Approve Status
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", backgroundColor: "#1976d2" }}
                  >
                    Dispatched Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mainData?.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {item?.requestedDucName
                        ? item?.requestedDucName
                        : item?.instrumentId
                          ? pushIArray
                              ?.filter(
                                (e) =>
                                  e?.label?.split(",")[0] == item?.instrumentId,
                              )?.[0]
                              ?.label.split(",")[1]
                          : ""}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {item?.DUCID}
                    </TableCell>
                    <TableCell>{item?.serialNumber}</TableCell>
                    <TableCell
                      align="center"
                      style={{
                        color: getStatusColor(item.status.inwordStatus),
                      }}
                    >
                      {item.status.inwordStatus == "yes" ? (
                        <VerifiedIcon />
                      ) : (
                        <DangerousIcon />
                      )}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        color: getStatusColor(item.status.dataSheetStatus),
                      }}
                    >
                      {item.status.dataSheetStatus == "yes" ? (
                        <VerifiedIcon />
                      ) : (
                        <DangerousIcon />
                      )}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        color: getStatusColor(item.status.approveStatus),
                      }}
                    >
                      {item.status.approveStatus == "yes" ? (
                        <VerifiedIcon />
                      ) : (
                        <DangerousIcon />
                      )}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        color: getStatusColor(item.status.dispatchedStatus),
                      }}
                    >
                      {item.status.dispatchedStatus == "yes" ? (
                        <VerifiedIcon />
                      ) : (
                        <DangerousIcon />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    );
  };

const filterSection = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "flex-end",
      gap: 1,
      flexWrap: "wrap",
      padding: "5px 0px",
    }}
  >
    {/* From date */}
    <Box sx={{ flex: "0 0 130px", minWidth: 0 }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          slotProps={{ textField: { size: "small", fullWidth: true } }}
          className="Listinputcss"
          label="From"
          value={from ? new Date(from) : null}
          format="dd/MM/yyyy"
          onChange={(newValue) => { setFrom(newValue); setSearched(false); }}
        />
      </LocalizationProvider>
    </Box>

    {/* To date */}
    <Box sx={{ flex: "0 0 130px", minWidth: 0 }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          slotProps={{ textField: { size: "small", fullWidth: true } }}
          className="Listinputcss"
          label="To"
          value={to ? new Date(to) : null}
          format="dd/MM/yyyy"
          onChange={(newValue) => { setTo(newValue); setSearched(false); }}
        />
      </LocalizationProvider>
    </Box>

    {/* Search By */}
    <Box sx={{ flex: "0 0 180px", minWidth: 0 }}>
      <Autocomplete
        className="Listinputcss"
        size="small"
        value={searchBy}
        options={[
          { key: "serviceReqNumber", label: "Service request number" },
          { key: "companyName", label: "Client" },
          { key: "AccreditationType", label: "Accreditation type" },
          { key: "PO Number", label: "PO number" },
          ...(settings?.companyHierarchy?.value
            ? [{ key: "companyHierarchy", label: "Division, department" }]
            : []),
        ]}
        isOptionEqualToValue={(option, value) => option.label === value}
        renderInput={(params) => <TextField {...params} label="Search by" />}
        onInputChange={(event, newInputValue) => {
          setSearchBy(newInputValue);
          setSearched(false);
        }}
      />
    </Box>

    {/* Search value — plain text */}
    {searchBy !== "Accreditation Type" && (
      <Box sx={{ flex: 1, minWidth: 120 }}>
        <TextField
          className="Listinputcss"
          fullWidth
          label={"Enter " + searchBy}
          size="small"
          inputProps={{ autoComplete: "off" }}
          variant="outlined"
          value={searchKey}
          onChange={(e) => { setSearchKey(e.target.value); setSearched(false); }}
        />
      </Box>
    )}

    {/* Accreditation type selector */}
    {searchBy === "Accreditation Type" && (
      <Box sx={{ flex: "0 0 160px", minWidth: 0 }}>
        <Autocomplete
          className="Listinputcss"
          size="small"
          value={AccreditationTypeOptions.find((o) => o.key === Type) || null}
          options={AccreditationTypeOptions}
          isOptionEqualToValue={(option, value) => option.key === value.key}
          renderInput={(params) => <TextField {...params} label="Type" />}
          onChange={(event, newValue) => {
            setType(newValue?.key);
            setSelectSRF("");
            setSearched(false);
          }}
        />
      </Box>
    )}

    {/* Accreditation SRF selector */}
    {searchBy === "Accreditation Type" && (
      <Box sx={{ flex: 1, minWidth: 120 }}>
        <Autocomplete
          className="Listinputcss"
          size="small"
          options={AccreditationTypeArray}
          getOptionLabel={(option) => option.serviceReqNumber}
          isOptionEqualToValue={(option, value) =>
            option.serviceReqNumber === value
          }
          renderInput={(params) => <TextField {...params} label="SRF" />}
          onChange={(event, newValue) => {
            setSelectSRF(newValue?.serviceReqNumber);
            setSearched(false);
          }}
        />
      </Box>
    )}

    {/* Search / Clear button */}
    <Button
      id="srflist-searchbtn"
      variant="contained"
      size="small"
      color={searched ? "error" : "primary"}
      sx={{ flexShrink: 0, height: 30 }}
      onClick={() => { searched ? clearSearch() : search(); handleFilterClose(); }}
    >
      {searched ? <RestartAltIcon /> : <SearchIcon />}
    </Button>

    {/* Hide SRF (conditional) */}
    {settings["hideSRF"]?.value === "true" && userType == 1 && (
      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ flexShrink: 0, height: 30, whiteSpace: "nowrap" }}
        onClick={() => setHideSrfData((prev) => ({ ...prev, hideRow: true }))}
      >
        Hide SRF
      </Button>
    )}

    {/* Excel export (desktop only) */}
    {!isMobile && (
      <Box sx={{ flexShrink: 0 }}>
        <ExcelDownload finalData={finalData} notNeededColumn={notNeededColumn} />
      </Box>
    )}
  </Box>
);

  const filterModal = () => {
    return (
      <Modal open={filterModalOpen} size="md">
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "calc(100% - 30%)",
            backgroundColor: "white",
            // border: "2px solid #000",
            boxShadow: 24,
            padding: "10px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            color="error"
            style={{ float: "right" }}
            onClick={handleFilterClose}
          >
            X
          </Button>
          {filterSection()}
        </Box>
      </Modal>
    );
  };

  const srfApproved = (id) => {
    let url = BASE_URL;
    let ids = Array.isArray(id) ? id : [id];
    axiosWithToken
      .post(url + `dynamic`, {
        query: `UPDATE srfs SET approvedby = ${userId} WHERE id IN (${ids.join(",")})`,
      })
      .then((res) => {
        toast("SRF is approved!");
        refresh();
      })
      .catch((err) => {
        console.log("error : ", err);
      });
  };
  const srfWithdraw = (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to withdraw the SRF?",
    );
    if (!isConfirmed) return;

    let url = BASE_URL;
    let ids = Array.isArray(id) ? id : [id];
    axiosWithToken
      .post(url + `dynamic`, {
        query: `UPDATE srfs SET approvedby = null WHERE id IN (${ids.join(",")})`,
      })
      .then((res) => {
        toast("SRF is withdraw successfully!");
        refresh();
      })
      .catch((err) => {
        console.log("error : ", err);
      });
  };

  const stopDueMail = (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to stop the due mail?",
    );
    if (!isConfirmed) return;

    let url = BASE_URL;
    let ids = Array.isArray(id) ? id : [id];
    axiosWithToken
      .post(url + `dynamic`, {
        query: `UPDATE srfs SET stopDueMailStatus = 2 WHERE id IN (${ids.join(",")})`,
      })
      .then((res) => {
        toast("Due mail stopped successfully!");
        refresh();
      })
      .catch((err) => {
        console.log("error : ", err);
      });
  };

  const activeDueMail = (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to active the due mail?",
    );
    if (!isConfirmed) return;

    let url = BASE_URL;
    let ids = Array.isArray(id) ? id : [id];
    axiosWithToken
      .post(url + `dynamic`, {
        query: `UPDATE srfs SET stopDueMailStatus = 1 WHERE id IN (${ids.join(",")})`,
      })
      .then((res) => {
        toast("Due mail actived successfully!");
        refresh();
      })
      .catch((err) => {
        console.log("error : ", err);
      });
  };

  const handleContinue = () => {
    if (actionValue === "delete") {
      if (window.confirm("Really want to delete SRF?"))
        submitSiteDelete(selected);
    } else if (actionValue === "approve") srfApproved(selected);
    else if (actionValue === "withdraw") srfWithdraw(selected);
    else if (actionValue === "stop-mail") stopDueMail(selected);
    else if (actionValue === "active-mail") activeDueMail(selected);

    setActionValue(""); // reset after action
  };

  const getUserList = () => {
    let url = BASE_URL;
    let sqlQuery = {
      query: `SELECT id, CONCAT(id, ', ', userName) AS label FROM users WHERE type != 3 AND status = 1`,
    };
    axiosWithToken
      .post(url + "dynamic", sqlQuery)
      .then((res) => {
        setHideSrfData((prev) => ({
          ...prev,
          usersData: res.data || [],
        }));
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getUserList", "Datasheet List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  };

  const getSrfNumber = () => {
    let url = BASE_URL;
    let sqlQuery = {
      query: `SELECT id, serviceReqNumber FROM srfs WHERE calType = ${hideSrfData?.calType} AND status = 1`,
    };
    axiosWithToken
      .post(url + "dynamic", sqlQuery)
      .then((res) => {
        setHideSrfData((prev) => ({
          ...prev,
          srfNumberData: res.data || [],
        }));
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getSrfNumber", "Datasheet List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  };

  const hideSelectedSRF = () => {
    const url = BASE_URL + "dynamic";
    const hideSrfUserIds = hideSrfData?.hideSrfUserIds;
    const selectedSRFIds = hideSrfData?.selectedSRFIds;

    const queries = [
      {
        query: `UPDATE srfs SET hideSrfUserIds = '${hideSrfUserIds}' WHERE id IN (${selectedSRFIds})`,
      },
      {
        query: `UPDATE datasheets SET hideSrfUserIds = '${hideSrfUserIds}' WHERE id IN (SELECT id FROM srfInstruments WHERE srfsId IN (${selectedSRFIds}))`,
      },
    ];

    Promise.all(queries.map((sqlQuery) => axiosWithToken.post(url, sqlQuery)))
      .then(() => {
        toast.success("SRF Hide Successfully!");
        refresh();
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "hideSelectedSRF", "Datasheet List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  };

  useEffect(() => {
    setRowDaata(generateRowDaata(srfList));
  }, [srfList]);

  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    if (hideSrfData?.calType) getSrfNumber();
  }, [hideSrfData?.calType]);

  return (
    <ListWrap>
      {dBStatus === "sick" ? (
        <h1 style={{ color: "red" }}>
          {" "}
          Record count is mismatching.
          <br /> please contact the support team. Tel: +91 9769847865
        </h1>
      ) : null}
      {dBStatus !== "sick" && (
        <>
          {filterModal()}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Toolbar id="srflist-createsrfbtn" className="ListCreatebutton">
              {(editAccess?.includes(0) || editAccess?.includes(9)) && (
                <Button
                  variant="contained"
                  size="small"
                  component={Link}
                  disabled={historyData}
                  to="/inward/editInward/0"
                  sx={{
                    ":hover": {
                      color: "#fff" /* or any other color you prefer */,
                    },
                  }}
                >
                  <b>create Inward</b>
                </Button>
              )}
            </Toolbar>
            <Box sx={{ display: "flex", gap: "0rem" }}>
              <Button
                style={{ display: isMobile ? "block" : "none" }}
                onClick={handleFilterOpen}
              >
                <FilterAltIcon />
              </Button>
              <Tooltip title="User Guide" placement="top-start">
                <Button
                  onClick={() => {
                    srfListGuides.drive();
                  }}
                  style={{ marginRight: "5px" }}
                >
                  <HelpIcon />
                </Button>
              </Tooltip>
            </Box>
          </div>
          {!isMobile && filterSection()}

          {hideSrfData?.hideRow && (
            <Grid
              container
              spacing={2}
              alignItems="center"
              style={{ padding: "5px 0px" }}
            >
              <Grid item xs={12} sm={2} md={2} lg={2} id="editsrf-dcno">
                <Autocomplete
                  size="small"
                  className="Listinputcss"
                  id="combo-box-demo"
                  options={[
                    { id: 1, label: "NABL" },
                    { id: 2, label: "IAS" },
                    { id: 3, label: "NON NABL" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  onChange={(event, newValue) => {
                    setHideSrfData((prev) => ({
                      ...prev,
                      calType: newValue ? newValue.id : null,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Calibration Type" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={3} md={3} lg={3} id="editsrf-dcno">
                <Autocomplete
                  multiple
                  size="small"
                  className="Listinputcss"
                  options={[
                    { id: "all", serviceReqNumber: "Select All" },
                    ...(hideSrfData?.srfNumberData || []),
                  ]}
                  getOptionLabel={(option) => option.serviceReqNumber}
                  value={
                    hideSrfData.selectedSRFIds
                      ? hideSrfData.selectedSRFIds
                          .split(",")
                          .map((id) =>
                            hideSrfData.srfNumberData.find(
                              (opt) => opt.id == id,
                            ),
                          )
                          .filter(Boolean)
                      : []
                  }
                  onChange={(event, newValue) => {
                    const isSelectAllClicked = newValue.some(
                      (item) => item.id === "all",
                    );

                    setHideSrfData((prev) => {
                      if (isSelectAllClicked) {
                        const allSelected =
                          prev.selectedSRFIds?.split(",").length ===
                          hideSrfData.srfNumberData.length;
                        return {
                          ...prev,
                          selectedSRFIds: allSelected
                            ? ""
                            : hideSrfData.srfNumberData
                                .map((opt) => opt.id)
                                .join(","),
                        };
                      }
                      return {
                        ...prev,
                        selectedSRFIds: newValue
                          .filter((opt) => opt.id !== "all")
                          .map((opt) => opt.id)
                          .join(","),
                      };
                    });
                  }}
                  limitTags={1}
                  renderOption={(props, option, { selected }) => {
                    const isAllSelected =
                      hideSrfData.selectedSRFIds?.split(",").length ===
                      hideSrfData.srfNumberData.length;
                    const isChecked =
                      option.id === "all" ? isAllSelected : selected;

                    return (
                      <li {...props}>
                        <Checkbox checked={isChecked} />
                        {option.serviceReqNumber}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select SRF Numbers" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={3} md={3} lg={3} id="editsrf-dcno">
                <Autocomplete
                  multiple
                  size="small"
                  className="Listinputcss"
                  options={[
                    { id: "all", label: "Select All" },
                    ...(hideSrfData?.usersData || []),
                  ]}
                  getOptionLabel={(option) => option.label}
                  value={
                    hideSrfData.hideSrfUserIds
                      ? hideSrfData.hideSrfUserIds
                          .split(",")
                          .map((id) =>
                            hideSrfData.usersData.find((opt) => opt.id == id),
                          )
                          .filter(Boolean)
                      : []
                  }
                  onChange={(event, newValue) => {
                    const isSelectAllClicked = newValue.some(
                      (item) => item.id === "all",
                    );

                    setHideSrfData((prev) => {
                      if (isSelectAllClicked) {
                        const allSelected =
                          prev.hideSrfUserIds?.split(",").length ===
                          hideSrfData.usersData.length;
                        return {
                          ...prev,
                          hideSrfUserIds: allSelected
                            ? ""
                            : hideSrfData.usersData
                                .map((opt) => opt.id)
                                .join(","),
                        };
                      }
                      return {
                        ...prev,
                        hideSrfUserIds: newValue
                          .filter((opt) => opt.id !== "all")
                          .map((opt) => opt.id)
                          .join(","),
                      };
                    });
                  }}
                  limitTags={1}
                  renderOption={(props, option, { selected }) => {
                    const isAllSelected =
                      hideSrfData.hideSrfUserIds?.split(",").length ===
                      hideSrfData.usersData.length;
                    const isChecked =
                      option.id === "all" ? isAllSelected : selected;

                    return (
                      <li {...props}>
                        <Checkbox checked={isChecked} />
                        {option.label}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Users" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={1.1} md={1.1} lg={1.1} id="editsrf-dcno">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={hideSelectedSRF}
                >
                  Hide
                </Button>
              </Grid>
            </Grid>
          )}

          {selected.length > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                margin: "10px 0px",
                flexWrap: "wrap",
              }}
            >
              <FormControl size="small" sx={{ minWidth: 220 }}>
                <Select
                  value={actionValue}
                  onChange={(e) => setActionValue(e.target.value)}
                  displayEmpty
                  renderValue={(val) => {
                    const opt = actionOptions.find((o) => o.value === val);
                    return (
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {opt ? (
                          opt.icon
                        ) : (
                          <RemoveCircleOutlineIcon
                            fontSize="small"
                            sx={{ opacity: 0.4 }}
                          />
                        )}
                        <span>{opt ? opt.label : "Select action"}</span>
                      </Box>
                    );
                  }}
                >
                  {actionOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      <ListItemIcon>{opt.icon}</ListItemIcon>
                      <ListItemText>{opt.label}</ListItemText>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Button
                variant="contained"
                size="small"
                disabled={!actionValue}
                startIcon={<PlayArrowIcon />}
                onClick={handleContinue}
              >
                Continue ({selected.length})
              </Button>
            </Box>
          )}
          <Box
            sx={{
              width: "100%",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minHeight: 0,
            }}
          >
            <TableContainer sx={{ flex: 1, overflow: "auto" }}>
              <Table
                stickyHeader
                aria-label="sticky table"
                size="small"
                id="srflist-table"
                sx={{ borderCollapse: "collapse" }}
              >
                <TableHead>
                  <TableRow>
                    {(editAccess?.includes(2) || editAccess?.includes(0)) && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={
                            selected.length > 0 &&
                            selected.length < rowDaata.length
                          }
                          checked={selected.length === rowDaata.length}
                          onChange={(event) => {
                            if (event.target.checked) {
                              setSelected(rowDaata.map((row) => row.id));
                            } else {
                              setSelected([]);
                            }
                          }}
                        />
                      </TableCell>
                    )}
                    {columns.map((column) => {
                      if (
                        !settings?.companyHierarchy?.value &&
                        (column.id === "Division" || column.id === "Department")
                      ) {
                        return null;
                      }
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          <b>{column.label}</b>
                        </TableCell>
                      );
                    })}
                    <TableCell>
                      <b>Actions</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowDaata?.length > 0 ? (
                    rowDaata?.map((row, index) => {
                      const comp = row.companyHierarchy
                        ? row.companyHierarchy?.split(",")
                        : [];
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          // style={{ textWrap: "nowrap"}}
                        >
                          {(editAccess?.includes(2) ||
                            editAccess?.includes(0)) && (
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isSelected(row.id)}
                                onChange={() => handleSelectRow(row.id)}
                              />
                            </TableCell>
                          )}
                          {columns.map((column) => {
                            let value = row[column.id];
                            if (
                              !settings?.companyHierarchy?.value &&
                              (column.id === "Division" ||
                                column.id === "Department")
                            ) {
                              return null;
                            }
                            if (column.id == "id") {
                              value = rowsPerPage * page + index + 1;
                            }
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  backgroundColor: row?.approvedby
                                    ? `${column.back}`
                                    : "transparent",
                                }}
                              >
                                {["customerName", "serviceReqNumber"].includes(
                                  column.id,
                                ) ? (
                                  <Link
                                    to={`/inward/editInward/${row.id}`}
                                    className="custom-link"
                                    title="Edit SRF"
                                  >
                                    {value}
                                  </Link>
                                ) : column.id === "Division" && comp[0] ? (
                                  comp[0]?.trim()
                                ) : column.id === "Department" && comp[1] ? (
                                  comp[1]?.trim()
                                ) : column.format &&
                                  typeof value === "number" ? (
                                  column.format(value)
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                          <SrfActionButtons
                            row={row}
                            isCSRF={isCSRF}
                            editAccess={editAccess}
                            showComponent={showComponent}
                            handleOpen={handleOpen}
                            SetSelectedColumn={SetSelectedColumn}
                            submitSiteDelete={submitSiteDelete}
                            srfApproved={srfApproved}
                            srfWithdraw={srfWithdraw}
                            handlePrintModalOpen={handlePrintModalOpen}
                            handleOpenTimeline={handleOpenTimeline}
                            handleOpenAuditModal={handleOpenAuditModal}
                            settings={settings}
                            handleSrfCopy={handleSrfCopy}
                            updateSrfDetails={updateSrfDetails}
                            openErrorModal={openErrorModal}
                            {...props}
                          />
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1} align="center">
                        <h6>
                          <b>Data Not Found</b>
                        </h6>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <RenderEmailModal
                open={open}
                handleClose={handleClose}
                selectedColumn={selectedColumn}
                refresh={refresh}
                formType={"srf"}
              />
            </TableContainer>
            <TablePagination
              id="srflist-pagination"
              rowsPerPageOptions={paginationrowsPerPageOptions}
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              component="div"
              colSpan={3}
              SelectProps={{
                inputProps: {
                  "aria-label": "rows per page",
                },
                native: true,
              }}
              ActionsComponent={TablePaginationActions}
            />
            <ToastContainer />
          </Box>
          {openProgressModal && progressModalRender()}
          {renderPrintModal()}
          {auditModalOpen && <SrfAudit />}
          {auditModalOpen && (
            <SrfAudit
              open={auditModalOpen}
              onClose={handleCloseAuditModal}
              row={selectedRow}
            />
          )}
          {errormodalIsOpen && (
            <ErrorModal
              errormodalIsOpen={errormodalIsOpen}
              closeErrorModal={closeErrorModal}
              errorMessage={errorMessage}
            />
          )}
          {loading && (
            <DownloadPdfLoaderModal loading={loading} name={"Inward"} />
          )}
        </>
      )}
    </ListWrap>
  );
}
